import Crud from '@/views/Lookup/Crud'

const routes = {
  path: '/lookup',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '',
      name: 'lookup',
      component: Crud,
    },
  ],
}

export default routes
